import { TermsDialogComponent } from './terms-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [TermsDialogComponent],
  imports: [DialogModule, ButtonModule],
  exports: [TermsDialogComponent],
})
export class TermsDialogModule {}
